import { csrfTokenService } from '~/apps/csrf/CsrfTokenService'
import { injectable } from '~/container'

@injectable()
export class HowDidYouHearAboutUsFetch {
  async submit(token: string, answer: string): Promise<boolean> {
    const { csrfToken } = await csrfTokenService()
    return $fetch<boolean>(
      `/_/fallback/_/endpoints/booking/${token}/how-did-you-hear-about-us/`,
      {
        method: 'POST',
        body: this.getFormData(answer),
        headers: {
          'X-CSRFToken': csrfToken,
        },
        timeout: 30000,
      },
    )
  }

  getFormData(answer) {
    const form = new FormData()
    form.append('value', answer)
    return form
  }
}
